var hooxSliderUgc = document.querySelector(".hoox-ugc-videos__items");

if (hooxSliderUgc && window.innerWidth <= 767) {
  var slider = new Swiper(hooxSliderUgc, {
    loop: true,
    slidesPerView: 1,
    centeredSlides: true,
    pagination: {
      el: '.hoox-ugc-videos__dots',
      clickable: true,
    },
    navigation: {
      nextEl: ".hoox-swiper-ugc-arrow-next",
      prevEl: ".hoox-swiper-ugc-arrow-prev",
    },
  });
}
